import { Component, Input, OnInit } from '@angular/core';
import { MatchGameService } from '../../match-game/matchGameService.service';
import { Station } from '../station.model';
import { StationList } from '../stations-list';


@Component({
  selector: 'app-rails-map',
  templateUrl: './rails-map.component.html',
  styleUrls: ['./rails-map.component.scss']
})
export class RailsMapComponent implements OnInit {

  @Input() stations: Station[];
  sss;

  constructor(private matchGameService: MatchGameService) { }

  ngOnInit(): void {
    this.sss = new StationList().stations;
  }

  moving;
  dragging = true;
  rotate = -45;
  minus = 1;

  tpick(event) {
    this.dragging = false;

    let clientX = event.clientX ? event.clientX : event.changedTouches[0].clientX;
    let clientY = event.clientY ? event.clientY : event.changedTouches[0].clientY;

    this.moving = event.target;
    setTimeout(() => {
      if (!this.dragging) {
        this.moving.style.transform = 'rotate(' + this.rotate + 'deg)';
        if (this.rotate) {
          this.rotate = 0;
        } else {
          this.rotate = 45 * (this.minus);
          this.minus = this.minus * (-1);
        }

      }
    }, 500);
    // this.moving.style.height = this.moving.clientHeight + 'px';
    // this.moving.style.width = this.moving.clientWidth + 'px';
    // this.moving.style.position = 'fixed';
    this.moving.style.left = (clientX - this.moving.clientWidth / 2) + 'px';
    this.moving.style.top = ((clientY - this.moving.clientHeight / 2) - 360) + 'px';
  }

  tmove(event) {
    if (this.moving) {
      if (event.clientX) {
        this.dragging = true;
        this.minus = 1;
        this.rotate = -45;
        // mousemove
        this.moving.style.left = (event.clientX - this.moving.clientWidth / 2) + 'px';
        this.moving.style.top = ((event.clientY - this.moving.clientHeight / 2) - 360) + 'px';
      } else {
        this.dragging = true;
        this.minus = 1;
        this.rotate = -45;
        // touchmove - assuming a single touchpoint
        this.moving.style.left = (event.changedTouches[0].clientX - this.moving.clientWidth / 2) + 'px';
        this.moving.style.top = ((event.changedTouches[0].clientY - this.moving.clientHeight / 2) - 360) + 'px';
      }
    }
  }

  // drop(ev) {
  //   ev.preventDefault();
  //   var containerId = ev.target.id;
  //   var stationId = ev.dataTransfer.getData("text");

  //   if (stationId == containerId) {
  //     this.currentStation = this.matchGameService.stationsArray.find(station => station.name == stationId);  
  //     document.getElementById(containerId).style.display = "none";
  //     this.matchGameService.rightAnswer(stationId);
  //   } else {
  //     this.matchGameService.wrongAnswer();
  //   }
  // }

  // tdrop(event) {
  //   let pageX = event.pageX ? event.pageX : event.changedTouches.item(0).pageX;
  //   let pageY = event.pageY ? event.pageY : event.changedTouches.item(0).pageY;
  //   // this.moving.style.zIndex = '-1';
  //   // var container_el: any = document.elementFromPoint(pageX, pageY);

  //   if (container_el.id == this.moving.id) {
  //     this.currentStation = this.matchGameService.stationsArray.find(station => station.name == this.moving.id);

  //     // if (this.currentStation.didYouKnow) {
  //     //   this.stationDidU = true;
  //     // } else {
  //     //   this, this.stationDidU = false;
  //     // }

  //     document.getElementById(this.moving.id).style.display = "none";
  //     this.matchGameService.rightAnswer(this.moving.id);
  //   } else {
  //     this.moving.style.left = '';
  //     this.moving.style.top = '';
  //     this.moving.style.position = 'unset';
  //     this.moving.style.zIndex = 'unset';
  //     this.moving = null;
  //     this.matchGameService.wrongAnswer();

  //     ////// להוציא מההערה כשיהיו תחנות ולהעיף את הWRONGANSWER מלמעלה

  //     // if (container_el.classList.contains('match-game-station')) { 
  //     //   this.matchGameService.wrongAnswer();
  //     // }
  //   }
  // }

  // allowDrop(ev) {
  //   ev.preventDefault();
  // }

  // drop(ev) {
  //   ev.preventDefault();
  //   var containerId = ev.target.id;
  //   var stationId = ev.dataTransfer.getData("text");

  //   if (stationId == containerId) {
  //     this.currentStation = this.matchGameService.stationsArray.find(station => station.name == stationId);  
  //     document.getElementById(containerId).style.display = "none";
  //     this.matchGameService.rightAnswer(stationId);
  //   } else {
  //     this.matchGameService.wrongAnswer();
  //   }
  // }

  // onCloseDidYouKnow() {
  //   this.matchGameService.didYouKnowCounter = 0;
  //   this.matchGameService.didYouKnow.next(false);
  // }
}
